/**
 * Temporary closure mode. Reopening: set TRACK_IS_CLOSED to false and rebuild.
 * This restores the original booking labels/links, FAQ, hours and event form,
 * removes the closure notice, and restores navigation's normal top position.
 * Original normal-operation copy stays in i18n/translations.js and i18n/faq.js.
 * Before reopening, verify BOOK_NOW_URL in booking.js and future event dates.
 * For a NEW closure later, bump the notice storage key in TrackClosureNotice.jsx.
 */
export const TRACK_IS_CLOSED = true;
export const CLOSURE_CONTACT_URL = "/contact?topic=closure";
export const FACEBOOK_URL = "https://www.facebook.com/share/198iyukZhA/?mibextid=wwXIfr";
export const INSTAGRAM_URL = "https://www.instagram.com/karting_krasna_polyana?stkn=MWRsdm1lNmFpZXkxdw==";

export const closureCopy = {
  bg: {
    contact: "Свържи се с нас",
    availability: "Докато пистата е затворена, не приемаме резервации за каране. Дата за отваряне все още не е обявена.",
    inquiry: "Можеш да ни пишеш за съществуваща резервация или друг въпрос. Изпращането на съобщение не запазва дата и час.",
    updates: "Следи Instagram и Facebook за датата на отваряне.",
    hoursLabel: "Временно затворено",
    hoursDay: "Всеки ден",
    contactDesc: "Пистата е временно затворена. Свържи се с нас за въпроси или съществуващи резервации.",
    eventsTitle: "Имаш въпрос за събитие?",
    eventsDesc: "Докато пистата е затворена, не потвърждаваме дати за събития. Можеш да се свържеш с нас за въпроси.",
    faqQuestion: "Мога ли да резервирам, докато пистата е затворена?",
    faqAnswer: "Не приемаме резервации за каране, докато пистата е затворена. Все още няма обявена дата за отваряне. За съществуваща резервация се свържи с нас на +359 888 860 950 или kartingsport@abv.bg. Новини за отварянето ще публикуваме в Instagram и Facebook.",
    subject: "Въпрос за затварянето / съществуваща резервация",
    ctaTitle: "Имаш въпрос? Свържи се с нас.",
  },
  en: {
    contact: "Contact us",
    availability: "While the track is closed, we are not accepting racing reservations. A reopening date has not been announced.",
    inquiry: "Message us about an existing reservation or another question. Sending a message does not reserve a date or time.",
    updates: "Follow Instagram and Facebook for the reopening announcement.",
    hoursLabel: "Temporarily closed",
    hoursDay: "Every day",
    contactDesc: "The track is temporarily closed. Contact us with questions or about existing reservations.",
    eventsTitle: "Have a question about an event?",
    eventsDesc: "While the track is closed, we are not confirming event dates. Contact us with your questions.",
    faqQuestion: "Can I book while the track is closed?",
    faqAnswer: "We are not accepting racing reservations while the track is closed. No reopening date has been announced. For an existing reservation, contact +359 888 860 950 or kartingsport@abv.bg. Reopening news will be posted on Instagram and Facebook.",
    subject: "Question about the closure / existing reservation",
    ctaTitle: "Have a question? Contact us.",
  },
};

// Derive temporary copy without modifying the normal translations.
// Turning off TRACK_IS_CLOSED automatically restores the original content.
export function withTrackStatus(copy, lang) {
  if (!TRACK_IS_CLOSED) return copy;
  const c = closureCopy[lang];
  return {
    ...copy,
    closure: { ...copy.closure, ...c },
    nav: { ...copy.nav, book: c.contact },
    hero: { ...copy.hero, cta_primary: c.contact },
    pricing: { ...copy.pricing, reserve: c.contact },
    marquee: copy.marquee.replace(/364[^·]+·\s*/, ""),
    pages: { ...copy.pages, contact_desc: c.contactDesc, events_desc: c.eventsDesc, booking_desc: c.inquiry },
    events: { ...copy.events, title: c.eventsTitle, desc: c.eventsDesc, cta_join: c.contact, upcoming_sub: c.availability + " " + c.updates },
    faq: {
      ...copy.faq,
      categories: copy.faq.categories.map((category) => ({
        ...category,
        // Keep normal reservation rules intact in faq.js for reopening.
        items: /^(Reservations|Резервации)$/.test(category.name)
          ? [{ q: c.faqQuestion, a: c.faqAnswer }]
          : category.items.map((item) => /364/.test(item.a) || /working hours|работното ви време/i.test(item.q) ? { ...item, a: c.availability + " " + c.updates } : item),
      })),
    },
  };
}
